import nacl from 'tweetnacl';
import util from 'tweetnacl-util';
import { TABLE_ASCII_CUSTOM } from '../../constants/encryption';

const encryptionSecret = process.env.REACT_APP_ENCRYPTION_KEY || window.REACT_APP_ENCRYPTION_KEY;
const key = nacl.hash(util.decodeUTF8(encryptionSecret)).slice(0, 32);

const Encryption = {
  encrypt: (data) => {
    const nonce = nacl.randomBytes(nacl.secretbox.nonceLength);
    const messageUint8 = util.decodeUTF8(JSON.stringify(data));
    const encrypted = nacl.secretbox(messageUint8, nonce, key);

    return `${util.encodeBase64(nonce)}.${util.encodeBase64(encrypted)}`;
  },

  decrypt: (encryptedData) => {
    const [nonce, encrypted] = encryptedData.split('.').map(util.decodeBase64);
    const decrypted = nacl.secretbox.open(encrypted, nonce, key);

    if (!decrypted) throw new Error('Error al desencriptar: Datos corruptos o clave incorrecta');

    return JSON.parse(util.encodeUTF8(decrypted));
  },
  encryptSimple: (text) => {
    const shift = (text.length % 10) + 3;
    let encryptedText = '';

    for (const mainChar of text) {
      let asciiValue = TABLE_ASCII_CUSTOM[mainChar] + shift;

      if (asciiValue > 125) {
        const diff = asciiValue - 125;
        asciiValue = 31 + diff;
      }

      for (const [key, value] of Object.entries(TABLE_ASCII_CUSTOM)) {
        if (asciiValue === value) {
          encryptedText += key;
          break;
        }
      }
    }

    return encryptedText;
  },
  decryptSimple: (encryptedText) => {
    const shift = (encryptedText.length % 10) + 3;
    let decryptedText = '';

    for (const mainChar of encryptedText) {
      let asciiValue = TABLE_ASCII_CUSTOM[mainChar] - shift;

      if (asciiValue < 32) {
        const diff = 32 - asciiValue;
        asciiValue = 126 - diff;
      }

      for (const [key, value] of Object.entries(TABLE_ASCII_CUSTOM)) {
        if (asciiValue === value) {
          decryptedText += key;
          break;
        }
      }
    }

    return decryptedText;
  },
};

export default Encryption;
